import styled from 'styled-components';

export const ProductSection = styled.div`
  padding: 4px 2px;
  text-align: center;
  color: #eee;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  @media (max-width: 950px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Product = styled.div`
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 10px;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 10px;
`;